class DskPhotoGallerySlider extends HTMLElement {
  connectedCallback() {
    if (typeof Swiper !== 'undefined') {
      this.init();
    } else {
      document.addEventListener('DOMContentLoaded', () => this.init());
    }
  }

  init() {
    const swiperEl = this.querySelector('.dsk-gallery-swiper');
    if (!swiperEl) return;

    this.swiperInstance = new Swiper(swiperEl, {
      initialSlide: 1,
      loop: false,
      speed: 600,
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 20,
      navigation: {
        prevEl: this.querySelector('.dsk-gallery-btn--prev'),
        nextEl: this.querySelector('.dsk-gallery-btn--next'),
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          centeredSlides: false,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 20,
        },
      },
    });
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }
  }
}

customElements.define('dsk-photo-gallery-slider', DskPhotoGallerySlider);
